import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "logo" }
const _hoisted_2 = {
  key: 0,
  src: "https://storage.googleapis.com/oanda-prod-tms-tms-marketing/proxy/images/tms-oanda-logo/tms_oanda_logo.svg",
  alt: "Dom Maklerski TMS Brokers"
}
const _hoisted_3 = {
  key: 1,
  src: "https://storage.googleapis.com/oanda-prod-tms-tms-marketing/proxy/images/oanda-logo/oanda.svg",
  alt: "OANDA"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isOandaPath)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.isOandaPath)
      ? (_openBlock(), _createElementBlock("img", _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}